export const APP_ID = "taggrs-checklist-v1";

// Auth Configuration
export const ALLOWED_DOMAINS = ["taggrs.io"];

// Webhooks
export const WEBHOOK_URL =
  "https://n8n.taggrs.cloud/webhook/d4b506d5-28a0-4c90-b742-ac5fb0055154";
export const UPSELL_WEBHOOK_URL =
  "https://n8n.taggrs.cloud/webhook/a5ad3e30-d460-4d2c-8dae-bab4d618fb65";
export const MAGIC_LINK_WEBHOOK_URL =
  "https://n8n.niekbv.nl/webhook/45445f09-5b86-4c15-b7cd-749aed5ed275";
export const CHARGEBEE_WEBHOOK_URL =
  "https://n8n.taggrs.cloud/webhook/a77725e0-cf24-44e6-bba9-81315b9429bf";

export const DEFAULT_UPSELL_SERVICES = [
  { name: "Server Side Tracking Setup", price: 750 },
  { name: "GTM Audit", price: 450 },
  { name: "Cookiebot Implementation", price: 250 },
  { name: "Enhanced Conversions Setup", price: 350 },
  { name: "GA4 Migration", price: 600 },
  { name: "Conversion API (CAPI)", price: 500 },
  { name: "Dashboarding / Looker Studio", price: 400 },
  { name: "Hourly Support", price: 125 },
];

export const DEFAULT_PLATFORMS_LIST = [
  { id: "ga4", label: "GA4" },
  { id: "gtm", label: "Google Tag Manager" },
  { id: "google_ads", label: "Google Ads" },
  { id: "meta", label: "Meta / Facebook" },
  { id: "tiktok", label: "TikTok" },
  { id: "pinterest", label: "Pinterest" },
  { id: "snapchat", label: "Snapchat" },
  { id: "linkedin", label: "LinkedIn" },
];

export const DEFAULT_CMP_LIST = [
  { id: "cookiebot", label: "Cookiebot" },
  { id: "cookieyes", label: "CookieYes" },
  { id: "iubenda", label: "iubenda" },
  { id: "axeptio", label: "Axeptio" },
];

export const MCC_ACCOUNTS = [
  "MCC-1",
  "MCC-2",
  "MCC-3",
  "MCC-4",
  "MCC-5",
  "MCC-6",
  "MCC-7",
  "MCC-8",
  "Other",
];

export const DEFAULT_TEMPLATES: any = {
  en: {
    kickoff: `Hi {{client_first_name}},

We are excited to get started with the {{service_type}}! To proceed, we need a few things from your side:

{{missing_items_list}}

{{billing_info_block}}

Let me know if you have any questions!

Best,
Lyron`,
    status: `Hi {{client_first_name}},

Here is a quick status update on the {{service_type}}. We are currently about {{progress_percentage}}% complete.

{{blocked_items_list}}

{{missing_items_list}}

Best,
Lyron`,
    handover: `Hi {{client_first_name}},

Great news! The {{service_type}} is now complete.

{{completed_items_list}}

{{blocked_items_list}}

Best,
Lyron`,
  },
  nl: {
    kickoff: `Hoi {{client_first_name}},

We zijn enthousiast om te starten met de {{service_type}}! Om verder te gaan, hebben we een paar dingen nodig:

{{missing_items_list}}

{{billing_info_block}}

Laat het weten als je vragen hebt!

Groet,
Lyron`,
    status: `Hoi {{client_first_name}},

Hier is een korte statusupdate over de {{service_type}}. We zijn momenteel ongeveer {{progress_percentage}}% klaar.

{{blocked_items_list}}

{{missing_items_list}}

Groet,
Lyron`,
    handover: `Hoi {{client_first_name}},

Goed nieuws! De {{service_type}} is nu afgerond.

{{completed_items_list}}

{{blocked_items_list}}

Groet,
Lyron`,
  },
};
